import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Routes,
  Route,
  Link,
} from "react-router-dom";
import { IntlProvider } from "react-intl";
import FileUploads from "./components/FileUploads";
import Header from "./components/Header";
import Login from "./components/Login";
import Protected from "./components/Protected";
import React, { useEffect, useState } from "react";
import ProductionSheetUpload from "./components/ProductionSheetUpload";
import PostProductionSheetUpload from "./components/PostProductionSheetUpload";
import Table from "./components/Table";
import BulkUpload from "./components/BulkUpload";
import Dashboard from "./components/Dashboard";
import FileUploadHistory from "./components/FileUploadHistory";
import UserLogin from "./components/UserLogin";

const locale = "en"; // Set the desired locale
const messages = {
  greeting: "Hello, World!",
  "user.login-title": "Login",
  "user.email": "Username",
  "user.login-button": "LOGIN",
};
function App() {
  const [isLoggedIn, setisLoggedIn] = useState(false);
  const [apiData, setApiData] = useState([]);

//   useEffect(() => {
//     console.log("login state::::", isLoggedIn);
//   }, [isLoggedIn]);

  return (
    <>
      <IntlProvider locale={locale} messages={messages}>
        <Router>
          <div>
            <Switch>
              <Route path="/fileUploads">
                <FileUploads />
              </Route>
              <Route path="/productionsheetupload">
                <ProductionSheetUpload />
              </Route>
              <Route path="/postproductionsheetupload">
                <PostProductionSheetUpload />
              </Route>
              <Route path="/header">
                <Header />
              </Route>
              <Route path="/history">
                <Table tableData={apiData} />
              </Route>
              <Route path="/bulkupload">
                <BulkUpload />
              </Route>
              <Route path="/dashboard">
                <Dashboard />
              </Route>
              <Route path="/fileuploadhistory">
                <FileUploadHistory tableData={apiData} />
              </Route>
              <Route path="/">
                <UserLogin setisLoggedIn={setisLoggedIn}/>
              </Route>
              {/* <Route path='/header'
          element={
            <Protected isLoggedIn={isLoggedIn}>
                <Header />
              </Protected>
            }
          /> */}
              {/* <Route path='/fileUploads'
            element={
              <Protected isLoggedIn={isLoggedIn}>
              <FileUploads />
            </Protected>
            }
          /> */}
              {/* <Route path="/fileUploads">
                <Protected isLoggedIn={isLoggedIn}>
                  <FileUploads />
                </Protected>
              </Route> */}
              {/* <Route path="/productionsheetupload">
                <Protected isLoggedIn={isLoggedIn}>
                  <ProductionSheetUpload />
                </Protected>
              </Route>
              <Route path="/postproductionsheetupload">
                <Protected isLoggedIn={isLoggedIn}>
                  <PostProductionSheetUpload />
                </Protected>
              </Route>
              <Route path="/postproductionsheetupload">
                <Protected isLoggedIn={isLoggedIn}>
                  <PostProductionSheetUpload />
                </Protected>
              </Route>
              <Route path="/header">
                <Protected isLoggedIn={isLoggedIn}>
                  <Header setisLoggedIn={setisLoggedIn}/>
                </Protected>
              </Route> */}
              <Route path="/login">
                <Login setisLoggedIn={setisLoggedIn} />
              </Route>
            </Switch>
          </div>
        </Router>
      </IntlProvider>
    </>
  );
}
export default App;
